export default function Terms() {
  const updated = "MAY 2026";
  return (
    <div
      className="max-w-[900px] mx-auto px-6 md:px-10 py-14 md:py-20"
      data-testid="terms-page"
    >
      <div className="micro-label">/ Terms &amp; Conditions</div>
      <h1 className="font-display font-black tracking-tight leading-[0.95] text-4xl md:text-5xl mt-3">
        Terms &amp; Conditions
      </h1>
      <p className="text-xs font-mono text-[var(--fg-2)] mt-3 tracking-widest">
        LAST UPDATED · {updated}
      </p>

      <div className="prose mt-10 space-y-8 text-sm leading-relaxed text-[var(--fg-2)]">
        <p>
          These Terms &amp; Conditions ("Terms") govern your use of Decal Labs
          (the "Service"), operated from South Africa. By creating an account
          or using the Service you agree to these Terms. If you do not agree,
          please do not use the Service.
        </p>

        <Section title="1. The Service">
          <p>
            Decal Labs is an image-to-SVG conversion tool intended for both
            racing-game livery design and general business / personal vector
            use. We are an independent service and are not affiliated with,
            endorsed by, or associated with any specific game, publisher, or
            brand.
          </p>
        </Section>

        <Section title="2. Your account">
          <p>
            You are responsible for the security of your account credentials
            and for all activity that occurs under your account. You must be
            18 or older, or have the consent of a legal guardian, to create an
            account.
          </p>
        </Section>

        <Section title="3. User content & intellectual property">
          <p>
            You retain full ownership of every image you upload and every SVG
            you generate. We do not claim any rights over your artwork. By
            uploading, you grant us a temporary, non-exclusive licence solely
            for the purpose of running the conversion and returning the
            result. We do not use your artwork for marketing, training, or any
            secondary purpose without your explicit consent.
          </p>
          <p className="mt-2">
            You are solely responsible for ensuring you have the rights,
            licences, and permissions necessary to upload and use any
            artwork. You must not upload content that infringes the
            intellectual property of any third party.
          </p>
        </Section>

        <Section title="4. Prohibited uploads & acceptable use">
          <p>You must not upload, generate, or use the Service to produce:</p>
          <ul className="list-disc pl-5 mt-2 space-y-1.5">
            <li>Content that infringes any third-party intellectual property right;</li>
            <li>Hateful, defamatory, harassing, or unlawful material;</li>
            <li>Sexually explicit content involving minors;</li>
            <li>Content designed to deceive, defraud, or impersonate another person or entity;</li>
            <li>Malware, exploits, or content designed to compromise the Service.</li>
          </ul>
          <p className="mt-2">
            We reserve the right to remove uploads and suspend accounts that
            breach this clause.
          </p>
        </Section>

        <Section title="5. Credits, billing & subscriptions">
          <p>
            Subscriptions are billed monthly in ZAR (South African Rand) via
            Peach Payments or PayFast. Each conversion consumes 5 credits.
            Failed conversions do not consume credits. Monthly allowances reset
            on your billing date. Credit-pack credits never expire. You may
            cancel at any time — access continues until the end of the
            current paid period.
          </p>
        </Section>

        <Section title="6. Refunds">
          <p>
            If something goes wrong with your subscription within the first 14
            days, email{" "}
            <a
              href="mailto:support@decallabs.co.za"
              className="underline text-[var(--fg)]"
            >
              support@decallabs.co.za
            </a>{" "}
            for a full refund. Credit-pack purchases are non-refundable once
            credits from the pack have been used.
          </p>
        </Section>

        <Section title="7. Service abuse, spam & fair usage">
          <p>
            Don't attempt to abuse the free trial via multiple accounts, IP
            cycling, scripted automation, or other circumvention measures.
            Don't use the Service to send spam, run mass-bots, or place
            unreasonable load on our infrastructure. Accounts found in breach
            may be suspended or terminated without refund.
          </p>
        </Section>

        <Section title="8. Service modifications">
          <p>
            We may add, remove, or change features at any time. Material
            changes that affect paid plans will be announced by email at least
            14 days in advance. Pricing changes apply only to renewals — you
            keep your current price until your next billing cycle.
          </p>
        </Section>

        <Section title="9. Account termination">
          <p>
            You may close your account at any time from the Billing portal or
            by emailing us. We may suspend or terminate accounts that breach
            these Terms, with a refund of unused subscription days at our
            discretion.
          </p>
        </Section>

        <Section title="10. Limitation of liability">
          <p>
            The Service is provided on an "as is" and "as available" basis.
            We do not guarantee that every SVG produced will be accepted by
            every third-party game or editor. To the maximum extent permitted
            by South African law, our total liability for any claim arising
            from your use of the Service is capped at the total amount you
            have paid us in the prior twelve months.
          </p>
        </Section>

        <Section title="11. Governing law">
          <p>
            These Terms are governed by the laws of the Republic of South
            Africa. Any dispute will be resolved in the South African courts
            of competent jurisdiction.
          </p>
        </Section>

        <Section title="12. Changes to these Terms">
          <p>
            We may update these Terms from time to time. The latest version is
            always posted on this page with the "Last updated" date. Continued
            use of the Service after a change constitutes acceptance of the
            updated Terms.
          </p>
        </Section>

        <Section title="13. Contact">
          <p>
            Questions about these Terms?{" "}
            <a
              href="mailto:support@decallabs.co.za"
              className="underline text-[var(--fg)]"
            >
              support@decallabs.co.za
            </a>
            .
          </p>
        </Section>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-display font-bold text-xl text-[var(--fg)]">{title}</h2>
      <div className="mt-2">{children}</div>
    </section>
  );
}
